module.exports = __webpack_public_path__ + "static/media/case-yachts.00cfea59.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case-yachts.jpg
// module id = 88
// module chunks = 3